module.exports = __webpack_public_path__ + "img/icon_parkingCoupon.fca24c0b.png";